module.exports = __webpack_public_path__ + "img/top-left-corner.d09590dc.svg";